/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIEmailAddress
 */
export interface APIEmailAddress {
    /**
     * 
     * @type {string}
     * @memberof APIEmailAddress
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmailAddress
     */
    readonly user: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmailAddress
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIEmailAddress
     */
    verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIEmailAddress
     */
    primary?: boolean;
}

/**
 * Check if a given object implements the APIEmailAddress interface.
 */
export function instanceOfAPIEmailAddress(value: object): value is APIEmailAddress {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIEmailAddressFromJSON(json: any): APIEmailAddress {
    return APIEmailAddressFromJSONTyped(json, false);
}

export function APIEmailAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmailAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'user': json['user'],
        'email': json['email'],
        'verified': json['verified'] == null ? undefined : json['verified'],
        'primary': json['primary'] == null ? undefined : json['primary'],
    };
}

export function APIEmailAddressToJSON(value?: Omit<APIEmailAddress, 'self'|'user'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'verified': value['verified'],
        'primary': value['primary'],
    };
}

